import { Component, type ReactNode } from 'react';
import { reportRenderFailure } from './browserErrors';
import { preferredRadarLocale } from '../i18n/radarLocalePreference';
import './browserErrors.css';

function recoveryUsesChinese() {
  if (typeof document === 'undefined') return false;
  // The provider is inside this boundary: it may not have mounted yet, and its
  // cleanup restores the shell language. Resolve private pages as it does.
  if (/^\/buyer-radar\/(?:app|workspaces|expo)(?:\/|$)/.test(window.location.pathname)) {
    return preferredRadarLocale().startsWith('zh');
  }
  return document.documentElement.lang.startsWith('zh') || /\/(?:zh|zh-hans|zh-hant)(?:\/|$)/.test(window.location.pathname);
}

export default class BrowserErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean; chinese: boolean; reference?: string }> {
  state = { failed: false, chinese: false, reference: undefined as string | undefined };

  static getDerivedStateFromError() { return { failed: true, chinese: recoveryUsesChinese() }; }

  componentDidCatch(error: unknown) {
    document.documentElement.removeAttribute('data-radar-boot');
    this.setState({ reference: reportRenderFailure(error) });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    const { chinese } = this.state;
    return <main className="ms-browser-error" role="alert" lang={chinese ? 'zh-Hans' : 'en'}><div>
      <p className="ms-browser-error-brand">MINDSTREAM</p>
      <h1>{chinese ? '页面暂时无法显示。' : 'This page couldn’t load.'}</h1>
      <p>{chinese ? '可以尝试重新加载。尚未提交的内容可能会丢失；已提交的操作请先确认结果，不要重复提交。' : 'Try reloading the page. Unsaved changes may be lost. Check the outcome of any submitted action before submitting it again.'}</p>
      {this.state.reference && <p>{chinese ? '联系支持时可提供此诊断编号：' : 'Diagnostic reference for support:'}<br /><code>{this.state.reference}</code></p>}
      <div className="ms-browser-error-actions"><button type="button" onClick={() => window.location.reload()}>{chinese ? '重新加载' : 'Reload page'}</button><a href="/">{chinese ? '返回 Mindstream' : 'Back to Mindstream'}</a></div>
    </div></main>;
  }
}
